<!-- =========================================================================================
  File Name: addRoomSidebar.vue
  Description: Add New Manager Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSettingSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <span class="flex items-center" style="word-break: normal;">
        <h4>STREAMING SETTINGS FOR:</h4>
         <vs-chip  color="primary">
          <p >{{dataLocationName}}</p>
        </vs-chip>
      </span>

        <feather-icon icon="XIcon" @click.stop="isSettingSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <vs-row>
    <vs-col vs-w="12">
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <!-- <div class="p-6" >
        <div class="flex">
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div>
        <br>
        <div v-if="ExBox">
        <label class="vs-select--label w-full">Select Existing Room</label>
        <v-select  v-if="ExBox" label="name"  multiple :closeOnSelect="true" v-model="dataRoom"  :options="rooms"   />
        </div>

      </div> -->
      <!-- <div class="pl-6 pr-6 pt-0" v-if="NewBox"> -->
      <div class="p-6">

        <vs-input label="Server *" v-model="dataServer" class="w-full mb-base" name="server" maxlength="100" />
                  <label class="vs-input--label">Password *</label>

        <vx-input-group >
        <template slot="append">
          <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
            <span @click="showPassword = !showPassword">
                    <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                    <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
              </span>
          </div>
        </template>
        <vs-input 
          maxlength="20"
          ref="password"
          v-model="dataPassword" 
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          v-bind:type="[showPassword ? 'text' : 'password']" 
          name="password"
          placeholder="Password"
          class="w-full no-right-border"
        />
      </vx-input-group>
       <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span><br><br>
        <!-- <vs-input label="Password *" v-model="dataPassword " class="w-full mb-base" name="pass" /> -->
           <label for="" class="vs-input--label">Video Width *</label>
      <vx-input-group class="">
      <template slot="append">
        <div class="append-text bg-primary">
          <span>px</span>
        </div>
      </template>
     <vs-input v-model="dataWidth"  @input="checkNumber" class="w-full" name="width" maxlength="100" v-validate="'required|between:100,3000'"/>
    </vx-input-group>
    <span class="text-danger text-sm" v-show="errors.has('width')">{{ errors.first('width') }}</span>
    <br><br>
       <label for="" class="vs-input--label" maxlength="100">Video Height *</label>
        <vx-input-group >
      <template slot="append">
        <div class="append-text bg-primary">
          <span>px</span>
        </div>
      </template>
        <vs-input  @input="checkNumber"  v-model="dataHeight" class="w-full" maxlength="100" name="height" v-validate="'required|between:100,3000'" />
    </vx-input-group>
        <span class="text-danger text-sm" v-show="errors.has('height')">{{ errors.first('height') }}</span>



      </div>
    </component>
     </vs-col>
    </vs-row>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSettingSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

import {
  CREATE_LOCATION_CAMERA_SETTING,
} from '@/graphql'

export default {
  props: {
    isSettingSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      dataLocationName:'',
      dataName: '',
      dataServer: '',
      dataPassword: '',
      dataWidth: '',
      dataHeight: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      showPassword:false
    }
  },
  watch: {
    isSettingSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id,name,camera_setting} = JSON.parse(JSON.stringify(this.data))
         camera_setting.forEach(setting => {
        if(setting.key==='server_name'){
          if(setting.value){
            this.dataServer=setting.value
           }
        }
         if(setting.key==='server_code'){
            if(setting.value){
              this.dataPassword=setting.value
            }
        }   
        if(setting.key==='video_height'){
          if(setting.value){
            this.dataHeight=setting.value
           }
        }
         if(setting.key==='video_width'){
            if(setting.value){
              this.dataWidth=setting.value
            }
        }
      }); 
        this.dataId = id
        this.dataLocationName = name
      }
    }
  },
  computed: {
    isSettingSidebarActiveLocal: {
      get () {
        return this.isSettingSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSettingSidebar')
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataServer && this.dataPassword && this.dataWidth && this.dataHeight
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      this.dataServer = ''
      this.dataPassword = ''
      this.dataWidth = ''
      this.dataHeight = ''
    },
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Location',
        text:  'Setting added successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$apollo
            .mutate({
              mutation: CREATE_LOCATION_CAMERA_SETTING,
              variables: {
                server: this.dataServer,
                code: this.dataPassword,
                width: this.dataWidth,
                height: this.dataHeight,
                location:this.dataId
              }
            }).then(response => {
                console.log(response)
              if (response.data.createLocationCameraSetting.status == 'Success') {
                this.StatusSuccess()
                this.$validator.reset()
                this.initValues()
                this.$emit('closeSettingSidebar')
              }
            }).catch(error => {
              console.log(error)
            })
        }
      })
    },
    checkNumber(){
        this.dataHeight = this.dataHeight.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        this.dataWidth = this.dataWidth.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
